import { SkeletonTile } from './SkeletonTile';

export const SkeletonGridTiles = ({
  /**
   * 12 is divisible by 2, 3 and 4
   *
   * mobile - 6 rows x 2
   * tablet - 4 rows x 3
   * desktop - 3 rows x 4
   */
  numberOfSkeletonTiles = 12,
}: {
  numberOfSkeletonTiles?: number;
}) => {
  const items = Array(numberOfSkeletonTiles).fill(null);

  return (
    <>
      {items.map((_, i) => (
        <SkeletonTile key={i} />
      ))}
    </>
  );
};
